/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  OrderFailure.tsx
*
* Project Title :  Checkout
*
* Description	  :
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Grandhi Srinivas(E528634)
*
* @Date			    : Jul 30, 2019
*
* @Version      : Version 1.0

* By            : Grandhi Srinivas (E528634)
* On            : Jul 31, 2019
* Description   : Updated code as ASDS-696
* By            : Avanthi G (E860178)
* On            : Sep 16, 2019
* Description   : Added Navigation to review order page from order failure page- ASDS-1176
 *
* By            : sivateja. peram
 * On            : Sep 30 2019
 * Description   : ASDS-1288
 *
 * * By            : sivateja. peram
 * On            : Nov 4 2019
 * Description   : ASDS-1299 (Implemented page refresh and Back navigation to Review order)
 * By            : H224423
 * On            : NOV 08 2019
 * Description   : Notification failure changes
 * By            : E807958
 * On            : NOV 08 2019
 * Description   : ASDS-1671
 *
 * By            : H224423
 * On            : Dec 09 2019
 * Description   : ASDS-1814 - Place order redirection changes
 *
 * By            : H422337
 * On            : Oct,22 2020
 * Description   : ASDS-3601,ASDS-3602 - Enhancements of phase-2 message changes
 *
 * By            : H422337
 * On            : Nov,06 2020
 * Description   : ASDS-3833- Error hadling scenario - place an order
 *
 * By            : H422335
 * On            : Nov 26 2020
 * Description   : Place Order custom error message fix
******************************************************************************/

import * as React from "react";
import { Grid, Notification } from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./OrderStatus.css";
import RouteConstants from "../constants/route-constants";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Layout from '../Layout/Layout';
import { Redirect } from "react-router";
import { ContactUsMessage } from "../Common/ContactUsMessage";
import parse from 'html-react-parser';

import { getFailureOrderDetails } from "../../../config/sessionStorage";

import {
    IreviewOrderState, IreviewOrderProps
} from '../utils/checkout-interfaces';
import { connect } from 'react-redux';
import PlaceOrderRequestActions from '../redux/actions/place-order-request-actions';
import GenericLoader from '../Loader/Loader';

interface IOrderFailureState {
    open: any;
    hasClickOut: any;
    failureOrderDetails: any;
}

interface IOrderFailureProps {
    stateOptions?: any;
    content?: any;
}

export class OrderFailure extends React.Component<
    IOrderFailureProps & RouteComponentProps & IreviewOrderProps,
    IOrderFailureState & IreviewOrderState
    > {
    constructor(props: IOrderFailureProps & RouteComponentProps & IreviewOrderProps) {
        super(props);
        this.state = {
            open: false,
            hasClickOut: true,
            TnCStatus: false,
            TnCUrl:'',
            TnCErrorMsg:'',
            failureOrderDetails: getFailureOrderDetails()
        };
        this.backToSearchProducts = this.backToSearchProducts.bind(this);
        this.placeOrder = this.placeOrder.bind(this);

    }

    backToSearchProducts() {
        this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);

    }
    async placeOrder() {

        await this.props.placeOrderRequest();
        const response = this.props.orderReference;

        if (response && 200 === response.status) {
            this.props.history.push(
                {
                    pathname: RouteConstants.ORDER_SUCCESS,
                    state: { orderNo: response.orderNo.toUpperCase() }
                });
        }
        else {
            this.props.history.push(
                {
                    pathname: RouteConstants.ORDER_FAILURE,
                    state: { status: 'allow' }
                });
        }

    }
    render() {
        /* checks the user allowed to access this component.       */
        /* TODO: Commented due to Build issue */
        /* if (getPreviousRoute() === RouteConstants.ORDER_FAILURE || (this.props.location.state && this.props.location.state.status === 'allow')) { */
        if (true ) {
            return (
                <React.Fragment>
                    {this.props.isOrderRequestInProgress &&
                        <GenericLoader text="Placing Your Order Request" className="features--loader" loading={true}
                            overlayColor='rgb(247, 247, 247)' />}
                    <Layout>
                        <Grid.Row>
                            <Grid.Column width={12} className="order-success-panel">
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={12} className="success-notify">
                                            {/*****************Notification starts here***********/}
                                            <Notification
                                                className="co-order-notification"
                                                severity="critical"
                                                hasIcon={true}
                                                title="We are unable to process your purchase!"
                                            >
                                                <div className="co-order-redirection-div">
                                                {this.state.failureOrderDetails && typeof this.state.failureOrderDetails.messageDisplay === 'undefined' ?
                                                <ContactUsMessage>Your Purchase is failed. Please try again later. If the issue still persists,</ContactUsMessage>
                                                :
                                                    this.state.failureOrderDetails && parse(this.state.failureOrderDetails.messageDisplay)
                                                }
                                                </div>
                                                                <div>
                                                                <a id="retry-link" href="javascript: void(0)" className="placeOrder pull-right" onClick={this.placeOrder}>
                                                                        TRY ORDERING AGAIN
                                                                  </a>
                                                                  </div>
                                                                  <a id="backToReviewOrder-link" href="javascript: void(0)" className="co-order-notify-actions-secondary pull-right" onClick={this.backToSearchProducts}>
                                                                        BACK TO SEARCH PRODUCTS
                                                                  </a>
                                            </Notification>
                                            {/*********************notiification ends here************** */}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                        </Grid.Row>


                    </Layout>
                </React.Fragment>
            );
        } else {
            return (<Redirect to={RouteConstants.PURCHASE_SOFTWARE} />)
        }

    }
}

function mapStateToProps(state) {
    return {
        orderReference: state.placeOrderRequestData.payload.orderReference,
        isOrderRequestInProgress: state.placeOrderRequestData.payload.isOrderRequestInProgress,
    }
}

export default connect(mapStateToProps,
    {
        placeOrderRequest: PlaceOrderRequestActions.retryPlaceOrderRequest,
    }
)(withRouter(OrderFailure));
